import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './ProjectFilter.module.css';

const ProjectFilter = ({categories, selectedCategory, onCategoryChange}) => (
  <div className={classes.filterContainer}>
    <button
      key="All"
      onClick={() => onCategoryChange('')}
      className={!selectedCategory ? `${classes.button} ${classes.active}` : classes.button}
    >
      All
    </button>
    {categories.map(category => (
      <button
        key={category}
        onClick={() => onCategoryChange(category)}
        className={
          selectedCategory === category ? `${classes.button} ${classes.active}` : classes.button
        }
      >
        {category}
      </button>
    ))}
  </div>
);

ProjectFilter.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCategory: PropTypes.string,
  onCategoryChange: PropTypes.func.isRequired,
};

export default ProjectFilter;
